// ─── Constantes ───────────────────────────────────────────────────────────────
export const CANAL = {
  whatsapp: { icon: '📱', color: '#22c55e', label: 'WhatsApp' },
  instagram: { icon: '📸', color: '#ec4899', label: 'Instagram' },
  facebook: { icon: '💬', color: '#3b82f6', label: 'Facebook' },
};

export function getCanalInfo(canal) {
  return CANAL[canal?.toLowerCase()] || { icon: '💬', color: '#94a3b8', label: canal };
}

export function fmtTime(d) {
  if (!d) return '';
  return new Date(d).toLocaleTimeString('es-CO', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'America/Bogota',
  });
}

export function fmtDate(d) {
  if (!d) return '';
  const tz = 'America/Bogota';
  const dt = new Date(d);
  const todayStr = new Date().toLocaleDateString('en-CA', { timeZone: tz });
  const dtStr = dt.toLocaleDateString('en-CA', { timeZone: tz });
  const yest = new Date();
  yest.setDate(yest.getDate() - 1);
  const yestStr = yest.toLocaleDateString('en-CA', { timeZone: tz });
  if (dtStr === todayStr) return 'Hoy';
  if (dtStr === yestStr) return 'Ayer';
  return dt.toLocaleDateString('es-CO', { weekday: 'short', day: '2-digit', month: 'short', timeZone: tz });
}

export function timeAgo(d) {
  if (!d) return '';
  const diff = Date.now() - new Date(d).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'ahora';
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  return `${Math.floor(h / 24)}d`;
}
